import { useReducer } from 'react'

/**
 * A key that changes every time `retry` is called
 * Add it to the dependencies of the effect or memo that should run again on retry
 */
export const useRetryKey = (): readonly [key: number, retry: VoidFunction] => useReducer((attempt: number) => attempt + 1, 0)
